export default [
  {
    path: '/super-consensus',
    name: 'SuperConsensus',
    component: () => import('@/views/super-consensus/index.vue'),
    meta: {
      auth: true,
      title: '超级共识',
      keepAlive: false,
      headerTheme: 'dark'
    }
  }
]
